export default __webpack_public_path__ + "static/media/Tool4.cae88b33.png";